import * as z from 'zod';

/**
 * Restaurant (branch) admin schemas — the branch a promotion or product row
 * belongs to. Shapes mirror `apps/cpanel/openapi-eats-admin.json`
 * (`v1LocalizedRestaurant`): the name rides localized, everything else stays
 * loose since only the display name is read.
 */

export const restaurantNameSchema = z
  .object({
    ru: z.string().nullish(),
    uz: z.string().nullish(),
    en: z.string().nullish(),
  })
  .loose();
export type RestaurantName = z.infer<typeof restaurantNameSchema>;

export const restaurantSchema = z
  .object({
    id: z.string().nullish(),
    name: restaurantNameSchema.nullish(),
    accepting_orders_now: z.boolean().optional(),
    merchant_id: z.string().nullish(),
  })
  .loose();
export type Restaurant = z.infer<typeof restaurantSchema>;
